import React, { useEffect, useState } from 'react';
import { Button, Input, Popover, useToasts } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import Icon from 'shared/components/Icon';
import Spacer from 'shared/components/Spacer';
import { useGetWorkflows, useTriggerWorkflow } from '../../../../hooks';
import { MenuContainer } from '../ResponseTags/style';

type ManualWorkflowTriggerProps = {
  responseData?: any;
  isBulkAction?: boolean;
  onSubmit?: (workflowId: string) => void;
  disabled?: boolean;
};

const Workflow = ({
  responseData,
  isBulkAction = false,
  onSubmit,
  disabled = false,
}: ManualWorkflowTriggerProps) => {
  const { t } = useTranslation();
  const [, setToast] = useToasts();
  const { data: allWorkflows = [], isFetching: isFetchingGetWorkflows } =
    useGetWorkflows();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [workflowList, setWorkflowList] = useState<any>([]);

  const { mutate: triggerWorkflow, isLoading } = useTriggerWorkflow(setToast);
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setWorkflowList(
      allWorkflows.filter(
        (item: any) =>
          item.type === 'MANUAL' &&
          !item.deleted &&
          item.active &&
          (item?.name || '')
            .toLowerCase()
            .includes(value?.trim().toLowerCase()),
      ),
    );
  };

  const handleRedirect = () => {
    window.open(`${location.origin}/app/workflow/create`, '_blank');
  };

  useEffect(() => {
    if (allWorkflows.length) {
      setWorkflowList(
        allWorkflows.filter(
          (item: any) => item.type === 'MANUAL' && !item.deleted && item.active,
        ),
      );
    }
  }, [allWorkflows]);

  return (
    <>
      <Button
        id="workflow-trigger-btn"
        inline
        type="secondary"
        aria-describedby="workflow-popover"
        onClick={(e: any) => setAnchorEl(e.currentTarget)}
        disabled={disabled}
      >
        <Icon
          glyph="triggerWorkflow"
          width="14px"
          height="14px"
          fill="#12344d"
        />{' '}
        <Spacer x={0.3} />
        {t('workflow.trigger_workflow_field')}
      </Button>
      <Popover
        id="workflow-popover"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuContainer>
          <div className="header">
            <Input
              startAdornment={
                <div style={{ paddingLeft: '8px' }}>
                  <Icon glyph="search" width={18} height={18} />
                </div>
              }
              placeholder={`${t('forms.placeholders.search')}`}
              defaultValue=""
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleFilterChange(e)
              }
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </div>
          {!isLoading && !isFetchingGetWorkflows ? (
            <div className="menu-content">
              {workflowList?.length ? (
                workflowList.map((opt: any) => (
                  <div
                    className="menu-item"
                    key={opt.workflow_id}
                    onClick={() => {
                      if (!isBulkAction && responseData) {
                        triggerWorkflow({
                          workflowId: opt.workflow_id,
                          responseId: responseData?.id,
                          surveyId: responseData?.survey_id,
                        });
                      } else {
                        if (onSubmit) onSubmit(opt.workflow_id);
                      }
                    }}
                  >
                    {opt.name}
                  </div>
                ))
              ) : (
                <div className="empty-placeholder">
                  {t('workflow.not_found')}
                </div>
              )}
            </div>
          ) : null}
          <div className="menu-footer">
            <div className="link" onClick={() => handleRedirect()}>
              {`+ ${t('workflow.new')}`}
            </div>
          </div>
        </MenuContainer>
      </Popover>
    </>
  );
};

export default Workflow;
